import "./IDMatch.css";

import {
  setIDMatchVisible,
  setLoginVisible,
} from "../../../store/modals/modalActions";
import { useAppDispatch, useAppSelector } from "../../../hooks/reduxHooks";

import Modal from "react-modal";
import { logout } from "../../../store/indexActions";

const IDMatch = () => {
  const dispatch = useAppDispatch();
  const infringementDetails = useAppSelector(
    (state) => state.fine.infringement
  );
  const modalStyle = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      overflow: "hidden",
      border: 0,
      boxShadow: "1px 0px 19px -4px rgba(0, 0, 0, 0.3)",
      height: 300,
      width: window.innerWidth > 480 ? "50%" : "75vw",
    },
  };

  const onLoginToAnotherAccountClicked = () => {
    dispatch(setIDMatchVisible(false));
    dispatch(setLoginVisible(true));
    logout(true);
  };
  const onBackToSearch = () => {
    if (window.location.pathname !== "/") {
      window.location.replace("/");
    }
    dispatch(setIDMatchVisible(false));
  };

  return (
    <Modal isOpen={true} style={modalStyle} ariaHideApp={false}>
      <div className="id-match-container">
        <p className="id-match-heading">ID Numbers do not match</p>
        <p className="id-match-subheading">
          Please login or register an account with ID number{" "}
          {infringementDetails?.idNumber} to pay this fine or search for another
          fine
        </p>
        <div className="id-match-button-container">
          <div
            className="id-match-button"
            style={{ backgroundColor: "#e97700", color: "white" }}
            onClick={() => onLoginToAnotherAccountClicked()}
          >
            Log into another account
          </div>
          <div
            className="id-match-button"
            style={{ border: "1px solid #18283c", color: "#18283c" }}
            onClick={() => onBackToSearch()}
          >
            Back to Search
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default IDMatch;
